module.exports = __webpack_public_path__ + "assets/sleep_mode.b4be536e.svg";